import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ChatConfigService } from '@client/app/modules/chat/services/chat-config.service';

@Injectable({
    providedIn: 'root',
})
export class IntercomProvider {
    private loaded = false;

    constructor (
        @Inject(DOCUMENT) private document: Document,
        private chatConfigService: ChatConfigService,
    ) {}

    addScript (): void {
        if (this.shouldStartIntercom()) {
            this.initScript();
        }
    }

    private shouldStartIntercom (): boolean {
        return !this.loaded;
    }

    private initScript (): void {
        const appId = this.chatConfigService.getIntercomId();
        const script = this.document.createElement('script');
        script.nonce = '3413c45d3a';
        script.innerHTML = `
            (function() {
                var w = window;
                var ic = w.Intercom;
                if (typeof ic === "function") {
                    ic('reattach_activator');
                    ic('update', w.intercomSettings);
                } else {
                    var d = document;
                    var i = function() {
                        i.c(arguments);
                    };
                    i.q = [];
                    i.c = function(args) {
                        i.q.push(args);
                    };
                    w.Intercom = i;
                    var l = function() {
                        var s = d.createElement('script');
                        s.type = 'text/javascript';
                        s.async = true;
                        s.src = 'https://widget.intercom.io/widget/${appId}';
                        var x = d.getElementsByTagName('script')[0];
                        x.parentNode.insertBefore(s, x);
                    };
                    l();
                }
            })();
        `;
        this.loaded = true;
        this.document.body.appendChild(script);
    }
}
